const getRequiredEnv = (key: string): string => {
  const value = import.meta.env[key];
  if (!value) {
    throw new Error(`No ENV '${key}'`);
  }
  return value;
};

type Environments = 'production' | 'staging' | 'development';

const getEnvironment = (): Environments => {
  const environment = getRequiredEnv('VITE_ENV');

  if (['production', 'staging', 'development'].includes(environment as Environments)) {
    return environment as Environments;
  }
  throw new Error('Invalid environment');
};

const currentEnv = getEnvironment();

export const config = {
  // Required environment variables
  apiUrl: getRequiredEnv('VITE_API_URL'),
  surveyApiUrl: getRequiredEnv('VITE_SURVEY_API_URL'),
  env: currentEnv,
  cloudflareImagesBaseUrl: getRequiredEnv('VITE_CLOUDFLARE_IMAGES_BASE_URL'),

  // Optional environment variables
  sentryRelease:
    import.meta.env.VITE_SENTRY_RELEASE ||
    `frontend@${import.meta.env.VITE_APP_VERSION || 'unknown'}`,

  // Logical variables - these are derived from the environment
  isDevelopment: ['development'].includes(currentEnv),
  useSentry: ['production', 'staging'].includes(currentEnv),
};
